export function trackUsage(action: string, value?: number) {
  gtag('event', action, {
    event_category: 'usage',
    value,
  });
}
